import { mergeAttributes, Mark, CommandProps, Editor } from '@tiptap/core'
import { invariant } from '@epic-web/invariant'

export type BaseHubInlineBlockOptions = {
  HTMLAttributes: {
    class: string
  }
  callbackOnPaste: (
    editor: Editor,
    id: string
  ) => string | undefined | void | false
}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    BaseHubInlineBlock: {
      /**
       * Set a basehub-inline-block mark
       */
      setBaseHubInlineBlock: (id: string) => ReturnType
      /**
       * Unset a basehub-inline-block mark
       */
      unsetBaseHubInlineBlock: () => ReturnType
    }
  }
}

export const BaseHubInlineBlock = Mark.create<BaseHubInlineBlockOptions>({
  name: 'basehub-inline-block',
  priority: 2000,

  addOptions() {
    return {
      HTMLAttributes: {
        class: 'rt-basehub-inline-block',
      },
      callbackOnPaste: (_editor: Editor, _id: string) => {},
    }
  },

  addAttributes() {
    return {
      id: {
        default: null,
        parseHTML: (element) => element.getAttribute('id') || element.id,
        renderHTML: ({ id }) => {
          if (!id) return {}
          return { id }
        },
        rendered: true,
      },
    }
  },

  parseHTML() {
    return [{ tag: `span[data-basehub-inline-block][id]` }]
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'span',
      mergeAttributes(
        {
          'data-basehub-inline-block': true,
        },
        this.options.HTMLAttributes,
        HTMLAttributes
      ),
      0,
    ]
  },

  addCommands() {
    return {
      setBaseHubInlineBlock:
        (id: string) =>
        ({ chain }: CommandProps) => {
          invariant(typeof id === 'string', 'id must be a string')
          return chain().setMark(this.name, { id }).run()
        },
      unsetBaseHubInlineBlock:
        () =>
        ({ chain }: CommandProps) => {
          return chain().unsetMark(this.name).run()
        },
    }
  },
})
